//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getContentDrawer = (state: ICuralateStore) => state.contentDrawer;

export const getContentDrawerSettings = createSelector(
  getContentDrawer,
  (contentDrawer) => contentDrawer.drawerSettings,
);

export const getIsContentDrawerEnabled = createSelector(
  getContentDrawerSettings,
  (drawerSettings) => !drawerSettings.disableContentDrawer,
);

export const getInitialFilters = createSelector(
  getContentDrawerSettings,
  (drawerSettings) => drawerSettings.filterOptions?.initialFilters,
);

export const getDisabledFilters = createSelector(
  getContentDrawerSettings,
  (drawerSettings) => drawerSettings.filterOptions?.lockedKeys,
);

export const getContextualHelp = createSelector(
  getContentDrawerSettings,
  (drawerSettings) => drawerSettings.contextualHelp,
);
